// Centralized API configuration
// Both production and preview use relative URLs since ingress handles /api routing

const getApiUrl = () => {
  // If we're running on localhost (development), use local backend
  if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
    return 'http://localhost:8001/api';
  }
  
  // For all deployed environments (production + preview), use relative URLs
  // Kubernetes ingress routes /api to the backend automatically
  return '/api';
};

export const API_BASE_URL = getApiUrl();
